import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 27374 32723"
    {...props}
  >
    <path
      d="M24033 5394h-7109v23359c0 1348-300 2344-907 2996-599 652-1378 974-2330 974-966 0-1760-329-2367-989-607-659-914-1648-914-2981V5394H3296c-1116 0-1940-247-2480-734C277 4165 0 3514 0 2705c0-832 285-1491 847-1978C1408 240 2225 0 3296 0h20737c1131 0 1963 247 2517 749 547 502 824 1154 824 1956 0 809-284 1460-839 1955-554 487-1386 734-2502 734z"
      style={{
        fill: "#2b2a29",
        fillRule: "nonzero",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
